<!-- <div class="container">
  <div class="container-wrapper">
    <h4>Mini Sites de cliente/a</h4>
    <div class="sites-wrapper">
      <div *ngFor="let site of clientSites" class="site-box">
        <h5 class="mb-3">
          <span class="me-2 fw-bolder">{{ site.title }}</span>
          <a [href]="site.url" target="_blank"><i class="fa fa-external-link"></i></a>
        </h5>
        <div class="iframe-integration">
          <p>Integración del iframe:</p>
          <div class="code-box">
            <code class="code" [textContent]="iframeText(site)"></code>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- <div id="initial-div" #initialDiv>
  <div class="img-container">
    <img src="/assets/img/sb_white.svg" alt="site builder white logo">
  </div>
  <div class="text-container">
    <p class="title">SITE BUILDER</p>
    <p class="subtitle">Powered by 3D Digital Venue</p>
  </div>
</div> -->
<div class="content-page">
  <!-- Headline -->

  <div class="content-headline">
    <div>
      <h3 class="headline-title">Minisites de cliente</h3>
    </div>
  </div>

  <div class="content-body">
    <div class="container-wrapper">
      <div class="sites-wrapper">
        <div *ngFor="let site of clientSites" class="site-box">
          <h5 class="mb-3">
            <span class="me-2 fw-bolder">{{ site.title }}</span>
            <a [href]="site.url" target="_blank"><i class="fa fa-external-link"></i></a>
          </h5>
          <div class="iframe-integration">
            <p>Integración del iframe:</p>
            <div class="code-box">
              <code class="code" [textContent]="iframeText(site)"></code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>